export const es = {
    table:{
        adjustTable: 'Ajustar tabla'
    }
}